<template>
	<div>
		<Card>
			
			<Form ref="searchForm" :model="searchForm" inline :label-width="80">
				<FormItem :label="$t('WithDrawAccount.Station')">
					<Select v-model="searchForm.stationId" :placeholder="$t('WithDrawAccount.SelectStation')" style="width: 200px" clearable>
						<Option v-for="item in stationList" :key="item.StationId" :value="item.StationId">
							{{ item.StationName || '-' }}
						</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSearch">{{ $t('Common.Search') }}</Button>
					<Button type="default" @click="handleReset" style="margin-left: 8px;">{{ $t('Common.Reset') }}</Button>
				</FormItem>
				<FormItem style="float: right;">
					<Button type="success" @click="handleAdd" icon="md-add">{{ $t('WithDrawAccount.Add') }}</Button>
				</FormItem>
			</Form>
		</Card>

		<Card>
			<Table border :columns="columns" :data="tableData" :loading="tableLoading">
				<template #channel="{ row }">
					<Tag :color="getChannelColor(row.Channel)">
						{{ getChannelText(row.Channel) }}
					</Tag>
				</template>
				<template #isDefault="{ row }">
					<Tag :color="row.IsDefault === 1 ? 'primary' : 'default'">
						{{ row.IsDefault === 1 ? $t('WithDrawAccount.Default') : $t('WithDrawAccount.Normal') }}
					</Tag>
				</template>
				<template #enable="{ row }">
					<Tag :color="row.Enable === 1 ? 'success' : 'default'">
						{{ row.Enable === 1 ? $t('WithDrawAccount.Enabled') : $t('WithDrawAccount.Disabled') }}
					</Tag>
				</template>
				<template #createTime="{ row }">
					{{ formatDateTime(row.CreateTime) }}
				</template>
				<template #action="{ row }">
					<Button type="primary" size="small" @click="handleEdit(row)" style="margin-right: 5px;">{{ $t('WithDrawAccount.Edit') }}</Button>
					<Button type="warning" size="small" @click="handleToggleStatus(row)">{{ row.Enable === 1 ? $t('WithDrawAccount.Disable') : $t('WithDrawAccount.Enable') }}</Button>
				</template>
			</Table>
			<div style="margin-top: 16px; text-align: right;">
				<Page
					:total="pagination.total"
					:current="pagination.current"
					:page-size="pagination.pageSize"
					:page-size-opts="[10, 20, 50, 100]"
					show-total
					show-sizer
					@on-change="handlePageChange"
					@on-page-size-change="handlePageSizeChange"
				/>
			</div>
		</Card>

		<!-- 新增/编辑弹窗 -->
		<Modal
			v-model="modalVisible"
			:title="modalTitle"
			:mask-closable="false"
			@on-cancel="handleModalCancel"
			width="600"
		>
			<Form ref="ruleForm" :model="formData" :rules="formRules" :label-width="120">
				<FormItem :label="$t('WithDrawAccount.Station')" prop="stationId">
					<Select v-model="formData.stationId" :placeholder="$t('WithDrawAccount.PleaseSelectStation')">
						<Option v-for="item in stationList" :key="item.StationId" :value="item.StationId">
							{{ item.StationName || '-' }}
						</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.Channel')" prop="channel">
					<Select v-model="formData.channel" :placeholder="$t('WithDrawAccount.SelectChannel')">
						<Option value="stripe">Stripe</Option>
						<Option value="bank">{{ $t('WithDrawAccount.BankAccount') }}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.AccountName')" prop="accountName">
					<Input v-model="formData.accountName" :placeholder="$t('WithDrawAccount.PleaseEnterAccountName')" />
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.ReceiveAccount')" prop="receiveAccount">
					<Input v-model="formData.receiveAccount" :placeholder="getReceiveAccountPlaceholder(formData.channel)" />
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.Email')" prop="email">
					<Input v-model="formData.email" :placeholder="$t('WithDrawAccount.PleaseEnterEmail')" />
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.Phone')" prop="phone">
					<Input v-model="formData.phone" :placeholder="$t('WithDrawAccount.PleaseEnterPhone')" />
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.IsDefault')" prop="isDefault">
					<RadioGroup v-model="formData.isDefault">
						<Radio :label="1">{{ $t('WithDrawAccount.Yes') }}</Radio>
						<Radio :label="0">{{ $t('WithDrawAccount.No') }}</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.EnableStatus')" prop="enable">
					<RadioGroup v-model="formData.enable">
						<Radio :label="1">{{ $t('WithDrawAccount.Enabled') }}</Radio>
						<Radio :label="0">{{ $t('WithDrawAccount.Disabled') }}</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.Remark')" prop="remark">
					<Input v-model="formData.remark" type="textarea" :rows="3" :placeholder="$t('WithDrawAccount.PleaseEnterRemark')" />
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="handleModalCancel">{{ $t('Common.Cancel') }}</Button>
				<Button type="primary" @click="handleModalOk" :loading="modalLoading">{{ $t('Common.Confirm') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import webapi from '../../../webapi';

	export default {
		name: 'WithDrawAccount',
		data() {
			return {
				searchForm: {
					stationId: undefined,
					channel: undefined,
					enable: undefined
				},
				columns: [],
				tableData: [],
				tableLoading: false,
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				modalVisible: false,
				modalTitle: '',
				modalLoading: false,
				isEdit: false,
				currentId: null,
				formData: {
					stationId: undefined,
					channel: 'stripe',
					receiveAccount: '',
					accountName: '',
					email: '',
					phone: '',
					isDefault: 0,
					enable: 1,
					remark: ''
				},
				formRules: {},
				stationList: []
			};
		},
		computed: {
			...mapState({
				Stations: 'Stations'
			})
		},
		watch: {
			// 监听语言变化，重新初始化列定义和表单规则
			'$i18n.locale'() {
				this.initColumns();
				this.initFormRules();
				this.modalTitle = this.isEdit ? this.$t('WithDrawAccount.EditTitle') : this.$t('WithDrawAccount.AddTitle');
			}
		},
		created() {
			this.initColumns();
			this.initFormRules();
			this.modalTitle = this.$t('WithDrawAccount.AddTitle');
			this.getStationList();
			this.getAccountList();
		},
		methods: {
			// 邮箱验证
			validateEmail(rule, value, callback) {
				if (!value) {
					callback();
					return;
				}
				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailRegex.test(value)) {
					callback(new Error(this.$t('WithDrawAccount.EmailFormatError')));
				} else {
					callback();
				}
			},

			// 手机号验证
			validatePhone(rule, value, callback) {
				if (!value) {
					callback();
					return;
				}
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(value)) {
					callback(new Error(this.$t('WithDrawAccount.PhoneFormatError')));
				} else {
					callback();
				}
			},

			// 初始化表单列表
			initColumns() {
				this.columns = [
					{
						title: this.$t('SplitRule.Index'),
						type: 'index',
						width: 80,
						align: 'center'
					},
					{
						title: this.$t('WithDrawAccount.Station'),
						key: 'StationName',
						minWidth: 150
					},
					{
						title: this.$t('WithDrawAccount.Channel'),
						slot: 'channel',
						width: 120,
						align: 'center'
					},
					{
						title: this.$t('WithDrawAccount.AccountName'),
						key: 'AccountName',
						minWidth: 120
					},
					{
						title: this.$t('WithDrawAccount.ReceiveAccount'),
						key: 'ReceiveAccount',
						minWidth: 200
					},
				
					{
						title: this.$t('WithDrawAccount.Email'),
						key: 'Email',
						minWidth: 180
					},
					{
						title: this.$t('WithDrawAccount.Phone'),
						key: 'Phone',
						width: 130
					},
					{
						title: this.$t('WithDrawAccount.Default'),
						slot: 'isDefault',
						width: 80,
						align: 'center'
					},
					{
						title: this.$t('WithDrawAccount.EnableStatus'),
						slot: 'enable',
						width: 100,
						align: 'center'
					},
					{
						title: this.$t('SplitRule.CreateTime'),
						slot: 'createTime',
						width: 180,
						align: 'center'
					},
					{
						title: this.$t('WithDrawAccount.Remark'),
						key: 'Remark',
						minWidth: 150
					},
					{
						title: this.$t('WithDrawAccount.Operation'),
						slot: 'action',
						width: 220,
						align: 'center',
						fixed: 'right'
					}
				];
			},

			// 初始化表单验证规则
			initFormRules() {
				this.formRules = {
					stationId: [
						{ required: true, message: this.$t('WithDrawAccount.PleaseSelectStation'), trigger: 'change', type: 'number' }
					],
					channel: [
						{ required: true, message: this.$t('WithDrawAccount.PleaseSelectChannel'), trigger: 'change' }
					],
					receiveAccount: [
						{ required: true, message: this.$t('WithDrawAccount.PleaseEnterReceiveAccount'), trigger: 'blur' }
					],
					accountName: [
						{ required: true, message: this.$t('WithDrawAccount.PleaseEnterAccountName'), trigger: 'blur' }
					],
					email: [
						{ validator: this.validateEmail, trigger: 'blur' }
					],
					phone: [
						{ validator: this.validatePhone, trigger: 'blur' }
					]
				};
			},

			// 获取场站列表
			async getStationList() {
				try {
					const res = await this.$axios.post(webapi.base_api_url + '/Home/GetCurrentUserStations', {});
					if (res.status === 200 && res.data.Code === 0) {
						this.stationList = res.data.Data.List || [];
						console.log('场站列表数据:', this.stationList);
					}
				} catch (error) {
					console.error('获取场站列表失败:', error);
					this.$Message.error(this.$t('WithDrawAccount.GetStationListFail'));
				}
			},

			// 获取提现账号列表
			async getAccountList() {
				this.tableLoading = true;
				try {
					const params = {
						stationId: this.searchForm.stationId,
						channel: this.searchForm.channel,
						enable: this.searchForm.enable,
						pageIndex: this.pagination.current,
						pageSize: this.pagination.pageSize
					};

					const res = await this.$axios.post(webapi.base_api_url + '/Split/GetWithdrawAccounts', params);

					if (res.status === 200 && res.data.Code === 0) {
						this.tableData = res.data.Data.List || [];
						this.pagination.total = res.data.Total || 0;
					} else {
						this.$Message.error(res.data.Message || this.$t('WithDrawAccount.GetAccountListFail'));
					}
				} catch (error) {
					console.error('获取提现账号列表失败:', error);
					this.$Message.error(this.$t('WithDrawAccount.GetAccountListFail'));
				} finally {
					this.tableLoading = false;
				}
			},

			// 搜索
			handleSearch() {
				this.pagination.current = 1;
				this.getAccountList();
			},

			// 重置
			handleReset() {
				this.searchForm = {
					stationId: undefined,
					channel: undefined,
					enable: undefined
				};
				this.pagination.current = 1;
				this.getAccountList();
			},

			// 新增
			handleAdd() {
				this.isEdit = false;
				this.modalTitle = this.$t('WithDrawAccount.AddTitle');
				this.currentId = null;
				this.modalVisible = true;
				this.$nextTick(() => {
					this.$refs.ruleForm.resetFields();
				});
			},

			// 编辑
			handleEdit(row) {
				this.isEdit = true;
				this.modalTitle = this.$t('WithDrawAccount.EditTitle');
				this.currentId = row.Id;
				this.formData = {
					stationId: row.StationId,
					channel: row.Channel,
					receiveAccount: row.ReceiveAccount,
					accountName: row.AccountName,
					email: row.Email,
					phone: row.Phone,
					isDefault: row.IsDefault,
					enable: row.Enable,
					remark: row.Remark
				};
				this.modalVisible = true;
			},

			// 删除
			handleDelete(row) {
				this.$Modal.confirm({
					title: this.$t('WithDrawAccount.ConfirmDelete'),
					content: this.$t('WithDrawAccount.ConfirmDeleteContent'),
					onOk: async () => {
						try {
							const res = await this.$axios.post(webapi.base_api_url + '/Split/DeleteWithdrawAccount', {
								id: row.Id
							});

							if (res.status === 200 && res.data.Code === 0) {
								this.$Message.success(this.$t('WithDrawAccount.DeleteSuccess'));
								this.getAccountList();
							} else {
								this.$Message.error(res.data.Message || this.$t('WithDrawAccount.DeleteFail'));
							}
						} catch (error) {
							console.error('删除失败:', error);
							this.$Message.error(this.$t('WithDrawAccount.DeleteFail'));
						}
					}
				});
			},

			// 切换启用状态
			handleToggleStatus(row) {
				const newStatus = row.Enable === 1 ? 0 : 1;
				const actionText = newStatus === 1 ? this.$t('WithDrawAccount.Enable') : this.$t('WithDrawAccount.Disable');

				this.$Modal.confirm({
					title: `${this.$t('WithDrawAccount.ConfirmAction')}${actionText}`,
					content: `${this.$t('WithDrawAccount.ConfirmActionContent')}${actionText}${this.$t('WithDrawAccount.Account')}?`,
					onOk: async () => {
						try {
							const res = await this.$axios.post(webapi.base_api_url + '/Split/UpdateWithdrawAccountStatus', {
								id: row.Id,
								enable: newStatus
							});

							if (res.status === 200 && res.data.Code === 0) {
								this.$Message.success(`${actionText}${this.$t('WithDrawAccount.Success')}`);
								this.getAccountList();
							} else {
								this.$Message.error(res.data.Message || this.$t('WithDrawAccount.OperationFail'));
							}
						} catch (error) {
							console.error('操作失败:', error);
							this.$Message.error(this.$t('WithDrawAccount.OperationFail'));
						}
					}
				});
			},

			// 弹窗确定
			handleModalOk() {
				this.$refs.ruleForm.validate(async (valid) => {
					if (valid) {
						this.modalLoading = true;
						try {
							const apiUrl = webapi.base_api_url + '/Split/AddWithdrawAccount';

							const params = { ...this.formData };
							if (this.isEdit) {
								params.id = this.currentId;
								apiUrl = webapi.base_api_url + '/Split/UpdateWithdrawAccount';
							}

							console.log('提交参数:', params);
							const res = await this.$axios.post(apiUrl, params);

							if (res.status === 200 && res.data.Code === 0) {
								this.$Message.success(this.isEdit ? this.$t('WithDrawAccount.UpdateSuccess') : this.$t('WithDrawAccount.AddSuccess'));
								this.modalVisible = false;
								this.getAccountList();
							} else {
								this.$Message.error(res.data.Message || (this.isEdit ? this.$t('WithDrawAccount.UpdateFail') : this.$t('WithDrawAccount.AddFail')));
							}
						} catch (error) {
							console.error('操作失败:', error);
							this.$Message.error(this.isEdit ? this.$t('WithDrawAccount.UpdateFail') : this.$t('WithDrawAccount.AddFail'));
						} finally {
							this.modalLoading = false;
						}
					}
				});
			},

			// 弹窗取消
			handleModalCancel() {
				this.modalVisible = false;
				this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
			},

			// 分页变化
			handlePageChange(page) {
				this.pagination.current = page;
				this.getAccountList();
			},

			// 每页条数变化
			handlePageSizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.current = 1;
				this.getAccountList();
			},

			// 获取渠道文本
			getChannelText(channel) {
				const map = {
					stripe: this.$t('WithDrawAccount.Stripe'),
					bank: this.$t('WithDrawAccount.BankAccount'),
					alipay: this.$t('WithDrawAccount.Alipay')
				};
				return map[channel] || channel;
			},

			// 获取渠道颜色
			getChannelColor(channel) {
				const map = {
					stripe: 'primary',
					bank: 'success',
					alipay: 'warning'
				};
				return map[channel] || 'default';
			},

			// 获取收款账号占位符
			getReceiveAccountPlaceholder(channel) {
				const map = {
					stripe: this.$t('WithDrawAccount.EnterStripeAccount'),
					bank: this.$t('WithDrawAccount.EnterBankAccount'),
					alipay: this.$t('WithDrawAccount.EnterAlipayAccount')
				};
				return map[channel] || this.$t('WithDrawAccount.PleaseEnterReceiveAccount');
			},

			// 格式化日期时间
			formatDateTime(dateTime) {
				if (!dateTime) return '-';
				const date = new Date(dateTime);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			}
		}
	};
</script>

<style scoped>
	:deep(.ivu-form-item) {
		margin-bottom: 16px;
	}
</style>
